import * as Types from '../mutation-types'
import connectManagerClient from '@/lib/connect-client/connect-manager-client'
import connectAuthClient from '@/lib/connect-client/connect-auth-client'
import RtkBase from '@/lib/caster/rtk_base'
import RtkRover from '@/lib/caster/rtk_rover'
import RtkSettingInfo from '@/lib/caster/rtk_setting_info'

const state = {
  rtkSettingInfo: null,
  rtkBases: [],
  rtkRovers: [],
  // 補正情報モニタリング (caster /stats・/track プロキシ)
  casterStats: null, // { mountpoint, current, lastEnded }
  casterStatsHistory: [], // 1分集計スナップショットの配列
  casterTrack: null, // { mountpoint, rovers: [...] }
}

const getters = {
  rtkSettingInfo: state => state.rtkSettingInfo,
  rtkBases: state => state.rtkBases,
  rtkRovers: state => state.rtkRovers,
  casterStats: state => state.casterStats,
  casterStatsHistory: state => state.casterStatsHistory,
  casterTrack: state => state.casterTrack,
}

const mutations = {
  [Types.SET_RTK_SETTING_INFO](state, settingInfo) {
    state.rtkSettingInfo = settingInfo
  },
  [Types.SET_RTK_BASES](state, casterBases) {
    state.rtkBases = casterBases
  },
  [Types.SET_RTK_ROVERS](state, casterRovers) {
    state.rtkRovers = casterRovers
  },
  [Types.SET_CASTER_STATS](state, stats) {
    state.casterStats = stats
  },
  [Types.SET_CASTER_STATS_HISTORY](state, history) {
    state.casterStatsHistory = history
  },
  [Types.SET_CASTER_TRACK](state, track) {
    state.casterTrack = track
  },
}

const actions = {
  getRtkSettingInfo({ commit }) {
    connectManagerClient.getRtkSettingInfo().then(response => {
      if (response.data) {
        const info = RtkSettingInfo.fromApi(response.data)
        commit(Types.SET_RTK_SETTING_INFO, info)
      }
    })
  },
  listCasterBasesAndRovers({ commit }) {
    connectManagerClient.listCurrentCasterBaseAndClient().then(response => {
      const responseData = response.data.data
      if (responseData) {
        let items = responseData.ServersByOwner.items
        let bases = []
        for (let i = 0; i < items.length; i++) {
          const rtkBase = RtkBase.fromApi(items[i])
          bases.push(rtkBase)
        }
        commit(Types.SET_RTK_BASES, bases)

        items = responseData.ClientsByOwner.items
        let rovers = []
        for (let i = 0; i < items.length; i++) {
          const rtkBase = RtkRover.fromApi(items[i])
          rovers.push(rtkBase)
        }
        commit(Types.SET_RTK_ROVERS, rovers)
      }
    })
  },

  /**
   * 補正情報統計を取得する。historyMinutes を指定すると1分集計の履歴も更新する。
   * 404 (基準局の接続実績なし) は stats=null として扱う。
   */
  getCasterStats({ commit }, { historyMinutes = null } = {}) {
    return connectAuthClient
      .getCasterStats(historyMinutes)
      .then(response => {
        const data = response.data
        commit(Types.SET_CASTER_STATS, data)
        if (historyMinutes && data && data.history) {
          commit(Types.SET_CASTER_STATS_HISTORY, data.history)
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 404) {
          commit(Types.SET_CASTER_STATS, null)
        } else {
          console.error(error)
        }
      })
  },

  /**
   * 移動局軌跡 (GGA記録) を取得する。
   */
  getCasterTrack({ commit }) {
    return connectAuthClient
      .getCasterTrack()
      .then(response => {
        commit(Types.SET_CASTER_TRACK, response.data)
      })
      .catch(error => {
        if (error.response && error.response.status === 404) {
          commit(Types.SET_CASTER_TRACK, null)
        } else {
          console.error(error)
        }
      })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
